import { Button } from "@alpacahq/ui/old";

import type { Selection } from ".";
import { TransferTypeButton } from "./TransferTypeButton";

interface AssetSelectionFormProps {
  onPreviousClicked: () => void;
  onSelectionClicked: (selection: Selection) => void;
}

export const AssetSelectionForm = ({
  onPreviousClicked,
  onSelectionClicked,
}: AssetSelectionFormProps) => (
  <form
    className="flex w-full max-w-md flex-col gap-5"
    // Form is submitted by clicking buttons, no submit button
    onSubmit={(event) => event.preventDefault()}
  >
    <div className="flex flex-col gap-3">
      <TransferTypeButton
        label="Yes"
        onClick={() => onSelectionClicked("Yes")}
      />
      <TransferTypeButton label="No" onClick={() => onSelectionClicked("No")} />
      <TransferTypeButton
        label="I'm not sure"
        onClick={() => onSelectionClicked("I'm not sure")}
      />
    </div>
    <Button
      variant="v2/stroke"
      type="button"
      onClick={onPreviousClicked}
      className="w-fit"
    >
      Previous
    </Button>
  </form>
);
